// removed by extract-text-webpack-plugin
module.exports = {"portal-today-wrapper":"portal-today-wrapper___MXF-H","portal-today-date":"portal-today-date___2ii5X","portal-weather-temp":"portal-weather-temp___R17-g","portal-today-card":"portal-today-card___12Axa"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/components/notification-sidenav/today-tab.module.scss
// module id = 1000
// module chunks = 82